import { render, staticRenderFns } from "./AMisRenderer.vue?vue&type=template&id=3afa5368&scoped=true"
import script from "./AMisRenderer.vue?vue&type=script&lang=js"
export * from "./AMisRenderer.vue?vue&type=script&lang=js"
import style0 from "./AMisRenderer.vue?vue&type=style&index=0&id=3afa5368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa5368",
  null
  
)

export default component.exports